export default "__VITE_ASSET__D0Uf0rHt__"